module.exports = __webpack_public_path__ + "static/citizen-d64f6459e552a29d747b302f17deaacb.png";